/**
 * « DOS SANTOS anilson » devient « Dos Santos Anilson » : une majuscule au
 * debut de chaque mot, le reste en minuscules. Les fournisseurs rendent les
 * noms tels que chacun les a saisis. Un trait d'union ou une apostrophe
 * commencent un mot (« Jean-Pierre », « D'Almeida »).
 *
 * Pour un nom de personne seulement : « FC Guignes » y perdrait son sigle.
 */
export function formatName(name: string): string {
  return name
    .trim()
    .replace(/\s+/g, ' ')
    .toLocaleLowerCase('fr-FR')
    .replace(/(^|[\s'’-])(\p{L})/gu, (_match, before: string, letter: string) => before + letter.toLocaleUpperCase('fr-FR'))
}
